import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

/* Guardar productos */
export const getModelSaveProduct = createSelector(
    getModel,
    (model) => model.save,
);

export const getSaveData = createSelector(
    getModelSaveProduct,
    (model) => model.data,
);

export const getSaveProductErrors = createSelector(
    getModelSaveProduct,
    (model) => model.errors,
);

export const getSaveProductIsFetching = createSelector(
    getModelSaveProduct,
    (model) => model.isSaving,
);

/* Modal product status */
export const getProductModalIsOpen = createSelector(
    getModel,
    (model) => model.productModalIsOpen,
);

export const getInitialValuesAuthEmails = createSelector(
    getModel,
    (model) => model.initialValuesAuthEmails,
);

/* Accesories */
export const getAccessoriesModel = createSelector(
    getModel,
    (model) => model.accessories,
);

export const getAccessoriesData = createSelector(
    getAccessoriesModel,
    (model) => model.data.data,
);

export const getAccessoriesErrors = createSelector(
    getAccessoriesModel,
    (model) => model.errors,
);

export const getAccessoriesIsFetching = createSelector(
    getAccessoriesModel,
    (model) => model.isFetching,
);

export const getAccessoriesPagination = createSelector(
    getAccessoriesModel,
    (model) => model.data.pagination,
);

/* Documents */
export const getDocumentsModel = createSelector(
    getModel,
    (model) => model.documents,
);

export const getDocumentsData = createSelector(
    getDocumentsModel,
    (model) => model.data,
);

export const getDocumentsErrors = createSelector(
    getDocumentsModel,
    (model) => model.errors,
);

export const getDocumentsIsFetching = createSelector(
    getDocumentsModel,
    (model) => model.isFetching,
);

/* Inverter Brands */
export const getInverterBrands = createSelector(
    getModel,
    (model) => model.inverterBrands,
);

export const getInverterBrandsData = createSelector(
    getInverterBrands,
    (model) => model.data,
);

export const getIsFetchingInverterBrands = createSelector(
    getInverterBrands,
    (model) => model.isFetching,
);

export const getInverterBrandsErrors = createSelector(
    getInverterBrands,
    (model) => model.errors,
);

/* Inverters */
export const getInvertersModel = createSelector(
    getModel,
    (model) => model.inverters,
);

export const getInvertersData = createSelector(
    getInvertersModel,
    (model) => model.data.data,
);

export const getInvertersErrors = createSelector(
    getInvertersModel,
    (model) => model.errors,
);

export const getInvertersIsFetching = createSelector(
    getInvertersModel,
    (model) => model.isFetching,
);

export const getInvertersPagination = createSelector(
    getInvertersModel,
    (model) => model.data.pagination,
);

/* Panel Brands */
export const getPanelBrands = createSelector(
    getModel,
    (model) => model.panelBrands,
);

export const getPanelBrandsData = createSelector(
    getPanelBrands,
    (model) => model.data,
);

export const getIsFetchingPanelBrands = createSelector(
    getPanelBrands,
    (model) => model.isFetching,
);

export const getPanelBrandsErrors = createSelector(
    getPanelBrands,
    (model) => model.errors,
);

/* Panels */
export const getPanelsModel = createSelector(getModel, (model) => model.panels);

export const getPanelsData = createSelector(
    getPanelsModel,
    (model) => model.data.data,
);

export const getPanelsErrors = createSelector(
    getPanelsModel,
    (model) => model.errors,
);

export const getPanelsIsFetching = createSelector(
    getPanelsModel,
    (model) => model.isFetching,
);

export const getPanelsPagination = createSelector(
    getPanelsModel,
    (model) => model.data.pagination,
);

/* Templates */
export const getfetchTemplateCatalogs = createSelector(
    getModel,
    (model) => model.fetchTemplateCatalogs,
);

export const getIsFetchingTemplateCatalogs = createSelector(
    getfetchTemplateCatalogs,
    (fetchTemplateCatalogs) => fetchTemplateCatalogs.isFetching,
);

export const getfetchTemplateCatalogsData = createSelector(
    getfetchTemplateCatalogs,
    (fetchTemplateCatalogs) => fetchTemplateCatalogs.data || [],
);

export const getfetchTemplateCatalogsErrors = createSelector(
    getfetchTemplateCatalogs,
    (fetchTemplateCatalogs) => fetchTemplateCatalogs.errors || [],
);

// Incentive Offer Complements
export const getIncentiveOfferComplements = createSelector(
    getModel,
    (model) => model.incentiveOfferComplements,
);

export const getIsFetchingIncentiveOfferComplements = createSelector(
    getIncentiveOfferComplements,
    (incentiveOfferComplements) => incentiveOfferComplements.isFetching,
);

export const getIncentiveOfferComplementsData = createSelector(
    getIncentiveOfferComplements,
    (incentiveOfferComplements) => incentiveOfferComplements.data,
);
export const getIncentiveOfferComplementsErrors = createSelector(
    getIncentiveOfferComplements,
    (incentiveOfferComplements) => incentiveOfferComplements.errors,
);

export const getIsOpenEmailsModal = createSelector(
    getModel,
    (model) => model.isOpenEmailsModal,
);
